import { Flex, Typography } from "antd"
import React from "react"

const { Title, Text } = Typography

export function ProposalsHeader() {
  return (
    <Flex justify={"space-between"} align={"center"} gap={"small"}>
      <Flex align={"center"}>
        <Flex vertical>
          <Title className={"text-start"} level={2}>
            Proposal Review
          </Title>
          <Text type={"secondary"}>Review and approve proposal documents</Text>
        </Flex>
      </Flex>
      {/*<Space>*/}
      {/*  <Button disabled icon={<BellOutlined />} />*/}
      {/*</Space>*/}
    </Flex>
  )
}
